import { put, takeLatest, call, spawn, all } from 'redux-saga/effects';
import { personalDataActions } from '../../../application/actions/personalData';
import { loadingActions } from '../../../application/actions/ui_loaders';

import api from '../../api';

const apiPersonalData = api(process.env.REACT_APP_PERSONAL_DATA_API);



export function* validatePersonalData(action) {
  try {
    yield put(loadingActions.changeStatusLoadingValidatePersonalData({ isLoading: true }));

    const token = sessionStorage.getItem('authToken'); 
    const headers = {
      Authorization: `${token}`, 
      flujo: `ENRL3.1`,
    };

    const { data, error } = yield call(apiPersonalData.post, 'v1/validar', action.payload, headers);

    if (data)
      yield all([
        put(personalDataActions.validatePersonalDataSuccess(data)),
        put(loadingActions.changeStatusLoadingValidatePersonalData({ isLoading: false })),
      ]);
    else
      yield all([
        put(personalDataActions.validatePersonalDataError(error)),
        put(loadingActions.changeStatusLoadingValidatePersonalData({ isLoading: false })),
      ]);
  } catch (err) {
    /* istanbul ignore next */
    console.error('personaData error:', err);
    yield all([
      put(personalDataActions.validatePersonalDataError({ code: 500, message: err })),
      put(loadingActions.changeStatusLoadingValidatePersonalData({ isLoading: false })),
    ]);
  }
}

export function* registerPersonalData(action) {
  try {
    yield put(loadingActions.changeStatusLoadingRegisterPersonalData({ isLoading: true }));
    /* istanbul ignore next */
    const tokenProcess = sessionStorage.getItem('token') || action.payload.tokenProcess;
    /* istanbul ignore next */
    if (!tokenProcess) {
      throw new Error('Token de proceso no encontrado');
    }

     const headers = {
      Authorization: `${tokenProcess}`,
      flujo: `ENRL3.1`,
    };

    const { data, error } = yield call(apiPersonalData.post, 'v2/registrar', action.payload, headers);

    if (data)
      yield all([
        put(personalDataActions.registerPersonalDataSuccess({ ...action.payload, ...data })),
        put(loadingActions.changeStatusLoadingRegisterPersonalData({ isLoading: false })),
      ]);
    else
      yield all([
        put(personalDataActions.registerPersonalDataError(error)),
        put(loadingActions.changeStatusLoadingRegisterPersonalData({ isLoading: false })),
      ]);
  } catch (err) {
    /* istanbul ignore next */
    yield all([
      put(personalDataActions.registerPersonalDataError({ code: 500, message: err })),
      put(loadingActions.changeStatusLoadingRegisterPersonalData({ isLoading: false })),
    ]);
  }
}
export function* watchValidatePersonalData() {
  yield takeLatest(personalDataActions.validatePersonalData.type, validatePersonalData);
}
export function* watchRegisterPersonalData() {
  yield takeLatest(personalDataActions.registerPersonalData.type, registerPersonalData);
}
/* istanbul ignore next */
export default function* personalDataSaga() {
  yield spawn(watchValidatePersonalData);
  yield spawn(watchRegisterPersonalData);
}
